import { useQuery } from '@tanstack/react-query';

import { api } from '../api/client';

/** Fetch a single Job by id with adaptive polling.
 *
 *  Polls every 5 s while the job is ``pending`` or ``submitted`` — the
 *  two states the user is actively watching for progress. Once the job
 *  reaches a terminal state (``done`` / ``failed`` / ``cancelled``)
 *  polling stops; the user can pull-to-refresh from the list to force
 *  another fetch.
 */
export function useJob(jobId: number | string | undefined) {
  return useQuery({
    queryKey: ['job', String(jobId)],
    queryFn: () => api.getJob(Number(jobId)),
    enabled: jobId !== undefined && jobId !== '',
    refetchInterval: (q) => {
      const state = q.state.data?.state;
      return state === 'pending' || state === 'submitted' ? 5000 : false;
    },
    staleTime: 2000,
  });
}
